import React, { Component } from "react";
import DefaultFieldsFilter from "./DefaultFields";
import CustomFieldsFilter from "../EditUser/CustomFields";
import { Tabs } from "@adrianoferreira/wp-react-admin";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";

export const CreateUsers = (props) => {

	return(
		<div id="poststuff" className="display-data-box">
			<div id="slugdiv" className="postbox">
				<h2 className="hndle ui-sortable-handle"><span>Create Users</span></h2>
				<div className="inside" style={{display: 'block'}}>

					<p>Use this action if you want to create new posts through this particular endpoint, as well as taxonomies and custom fields</p>

					{props.endpoint.createUsers.map(
						(el, index) =>

							<FieldGroupContext.Provider key={index} value={{
								action: 'createUsers',
								currentItem: index,
								endpointId: props.id,
								endpoint: props.endpoint
							}}>

								<Tabs tabs={[
									{
										name:    'defaultFields',
										title:   'Default Fields',
										content: <DefaultFieldsFilter group={'defaultFields'} key={index + '-defaultFields'}/>
									},
									{
										name: 'customFields',
										title: 'Custom Fields',
										content: <CustomFieldsFilter key={index + '-customFields'} group={'customFields'}/>
									}
								]} />

							</FieldGroupContext.Provider>
					)}

				</div>
			</div>
		</div>
	)
};

export default CreateUsers;
